import React, { useState, useEffect, useRef, useContext } from "react";
import Breadcrumbs from "./Breadcrumb";
import "datatables.net-bs4/js/dataTables.bootstrap4";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import { Modal } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import { DataGrid } from "@material-ui/data-grid";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";
import { ToastContainer } from "react-toastify";
import TablePagination from "@material-ui/core/TablePagination";
import AuthContext from "../../../context/auth-context";
import { LocationService } from "../../../services/locations-service";
import { ProductReviewService } from "../../../services/product-review-service";
import { ProductService } from "../../../services/product-service";
import Select from "react-select";

export const Content = (props) => {
  const ctx = useContext(AuthContext);

  const authPermission = localStorage.getItem("PermissionDetails");

  const [createHide, setCreateEdit] = useState(true);
  const [editHide, setHideEdit] = useState(true);
  const [deleteHide, setHideDelete] = useState(true);

  useEffect(() => {
    JSON.parse(authPermission).forEach(function (loca) {
      if (
        loca.access_module.module_name == "PRODUCT_REVIEW" &&
        loca.permission_edit === true
      ) {
        setHideEdit(false);
      }
      if (
        loca.access_module.module_name == "PRODUCT_REVIEW" &&
        loca.permission_delete === true
      ) {
        setHideDelete(false);
      }

      if (
        loca.access_module.module_name == "PRODUCT_REVIEW" &&
        loca.permission_add === true
      ) {
        setCreateEdit(false);
      }
    });
  }, [authPermission]);

  const [page, setPage] = React.useState(0);

  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const [count, setDataCount] = useState(0);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const [submitloading, setSubmitLoading] = useState(true);

  const [state, setState] = useState(false);

  const [reviewID, setReviewID] = useState();

  const history = useHistory();

  const handleShow4 = (e) => {
    setState({ show4: true });
    setReviewID(e);
  };

  const handleClose = (e) => {
    setState({ show3: false });
  };

  
  const [productReview, setProductReview] = useState([]);
  const [products, setProducts] = useState([]);
  const [statusValue, setStatusValue] = useState("");
  const [productId, setProductId] = useState("");



  const fetchProducts = async () => {
    try {
      const products = await ProductService.allproductsNames();
      setProducts(products);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const productReviewsSearch = async (productId = "") => {
    try {
      const result = await ProductReviewService.productReviewDetailsSearch(rowsPerPage, page, statusValue,
        productId);
      setProductReview(result.results);
      setDataCount(result.pagination.total);
    } catch (err) {
      //toast
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
      } else {
        notifyWarning("Something Wrong");
      }
    }
  };

  const onDelete = async () => {
    //todo extra validations
    setSubmitLoading(false);
    try {
      await ProductReviewService.productReviewDelete(reviewID);

      setSubmitLoading(true);
      notify("Product review successfully deleted");
      handleClose();
      productReviewsSearch();
    } catch (err) {
      setSubmitLoading(true);
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
      } else {
        notifyWarning("Something Wrong");
      }

      //show error toast
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  useEffect(() => {
    productReviewsSearch(productId);
  }, [rowsPerPage, page, statusValue, productId]);

  const handleProductChange = (selectedOption, index) => {
    setProductId(selectedOption ? selectedOption.value : "");
    productReviewsSearch(selectedOption ? selectedOption.value : "");
  };

  let ProductOptions = products.map((product) => ({
    value: product.id,
    label: product.name,
  }));

  const clearFilters = () => {
    setProductId("");
    setStatusValue("");
    setPage(0);
    setRowsPerPage(10);
  };

  const calculateHeight = () => {
    // Approximate row height + header + footer
    return rowsPerPage * 52 + 150;
  };

  const columns = [
    {
      field: "id",
      headerName: "ID",
      flex: 1,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    },
    {
      field: "product",
      headerName: "Product",
      flex: 4,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return <div>{params.row.product ? params.row.product.name : 'N/A'}</div>;
      },
    },
    {
      field: "user",
      headerName: "User",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    },
    {
      field: "review",
      headerName: "Review",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    },
    {
      field: "rating",
      headerName: "Rating",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark center-h" : "deactive_dark center-h",
      headerClassName: ctx.darkMode ? "active_dark center-h" : "deactive_dark center-h",
      headerAlign: "center",  // Aligns the header text
      align: "center",
    },
    {
      field: "status",
      headerName: "Status",
      sortable: false,
      flex: 2,
      disableClickEventBubbling: true,
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        const handleClick = () => {
          window.open(`${window.location.origin}/product-review-edit/${params.row.id}`, '_blank');

        };
        if (params.row.status === "APPROVED") {
          return (
            <div onClick={handleClick} style={{ cursor: "pointer" }}>
              <span className="badge badge-success">APPROVED</span>
            </div>
          );
        } else if(params.row.status === "PENDING") {
          return (
            <div onClick={handleClick} style={{ cursor: "pointer" }}>
              <span className="badge badge-warning">PENDING</span>
            </div>
          );
        }else{
            return (
                <div onClick={handleClick} style={{ cursor: "pointer" }}>
                  <span className="badge badge-danger">REJECTED</span>
                </div>
              );
        }
      },
    },
    {
      field: "edit",
      headerName: "Edit",
      sortable: false,
      flex: 1,
      disableClickEventBubbling: true,
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return (
          <div
            onClick={() => {
              history.push(`/product-review-edit/${params.row.id}`);
            }}
            style={{ cursor: "pointer" }}
            hidden={editHide}
          >
            <i className="fas fa-pencil-alt text-secondary" />
          </div>
        );
      },
    },
    {
      field: "delete",
      headerName: "Delete",
      sortable: false,
      flex: 1,
      disableClickEventBubbling: true,
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return (
          <div hidden={deleteHide}>
            <i
              className="far fa-trash-alt ms-text-danger"
              onClick={() => {
                handleShow4(params.row.id)
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
        );
      },
    },
  ];

  return (
    <div className="ms-content-wrapper">
      <div>
        <ToastContainer />
      </div>
      <div className="row">
        <div className="col-md-12">
          <Breadcrumbs />
          <div className="ms-panel">
            <div className="ms-panel-header">
              <div className="row">
                <div className="col-md-10">
                  <h6>Product Reviews </h6>
                </div>
                <div>
                  <Modal
                    show={state.show4}
                    onHide={handleClose}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                  >
                    <Modal.Header>
                      <h3 className="modal-title has-icon ms-icon-round ">
                        Confirm Deletion
                      </h3>
                      <button
                        type="button"
                        className="close"
                        onClick={handleClose}
                      >
                        <span aria-hidden="true">×</span>
                      </button>
                    </Modal.Header>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "2vh",
                      }}
                    >
                      <h6 style={{ color: "red" }}>
                        Are you sure you want to remove this item ?
                      </h6>
                    </div>
                    <Modal.Footer>
                      <div className="col-md-2" hidden={submitloading}>
                        <div className="spinner spinner-7">
                          <div className="bounce1" />
                          <div className="bounce2" />
                          <div className="bounce3" />
                        </div>
                      </div>
                      <button
                        type="button"
                        className="btn btn-primary shadow-none"
                        // onClick={submitForm}
                        style={{ backgroundColor: "red" }}
                        onClick={onDelete}
                      >
                        Delete
                      </button>

                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={handleClose}
                      >
                        Cancel
                      </button>
                    </Modal.Footer>
                  </Modal>
                </div>
              </div>
              <div className="row mt-3">
                {/* <div className="col-md-4">
                  <label htmlFor="validationCustom15">Product</label>
                    <Select
                      options={ProductOptions}
                      onChange={handleProductChange}
                      isClearable
                      placeholder="Filter by Product"
                      value={ProductOptions.find(option => option.value === productId)}
                    />
                </div> */}
                <div className="col-md-3">
                  <label htmlFor="validationCustom15">Status</label>
                      <div className="input-group">
                        <select
                          name="status"
                          className="form-control"
                          value={statusValue}
                          id="selectstatus"
                          required
                          onChange={(event) => {
                            setStatusValue(event.target.value);
                          }}
                        >
                          <option value="">ALL</option>
                          <option value="PENDING">PENDING</option>
                          <option value="APPROVED">APPROVED</option>
                          <option value="REJECTED">REJECTED</option>
                        </select>
                      </div>
                </div>
                <div className="col-md-1">
                    <label htmlFor="validationCustom15"></label>
                    <div className="input-group">
                      <button
                          type="button"
                          className="btn btn-primary shadow-none"
                          onClick={clearFilters}
                        >
                          Clear
                      </button>
                    </div>
                  </div>
              </div>
            </div>
            <div className="ms-panel-body">
              <div className="table-responsive">
                <div style={{ minHeight: calculateHeight(), height: calculateHeight(), flex: "100%" }}>
                  <DataGrid
                    rows={productReview}
                    disableExtendRowFullWidth={false}
                    columns={columns}
                    pageSize={rowsPerPage}
                    pagination
                    hideFooter
                    autoHeight
                  />
                  <TablePagination
                    component="div"
                    count={count}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Content;
